import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';
import withImage from '../../../../shared/components/utils/hoc/withImage';

/**
 * Styled full-screen image component for pause ad background.
 * Displays the ad image covering the entire screen with object-fit cover.
 */
const FullScreenImage = styled.img<React.CSSProperties>`
  position: fixed;
  top: 0;
  left: 0;
  width: ${Screen.widthRatio * 1920}px;
  height: ${Screen.widthRatio * 1080}px;
  object-fit: cover;
`;

export default withImage(FullScreenImage, false);
